import {fetch} from "../../utils/dataAccess";
import {ITEM_PER_PAGE} from "../../config/_pagination";

export function error(error) {
    return {type: "LINE_ITEM_RETAILER_LIST_ERROR", error};
}

export function loading(loading) {
    return {type: "LINE_ITEM_RETAILER_LIST_LOADING", loading};
}

export function success(retrieved) {
    return {type: "LINE_ITEM_RETAILER_LIST_SUCCESS", retrieved};
}

let listRequest = null;
export function list(params = `pagination=true&itemsPerPage=${ITEM_PER_PAGE}&page=1`) {
    return dispatch => {
        if (!!listRequest) {
            return;
        }

        dispatch(loading(true));
        listRequest = fetch("/line_items_retailer_list?" + params);
        listRequest.then(response => {
            response.json().then(retrieved => {
                dispatch(loading(false));
                dispatch(success(retrieved));
            }).catch(() => {
                dispatch(loading(false));
            });
        }).catch(error => {
            // canceled
        }).finally(() => listRequest = null);
    }
}

export function reset() {
    return dispatch => {
        dispatch({type: "LINE_ITEM_RETAILER_LIST_RESET"});
    };
}

export function fetchRetailerLineItems(params = '', includeToShip = false) {
    const query = includeToShip ? `${params}&include_to_ship=true` : params;

    return fetch("/line_items_retailer_list?" + query).then(response => response.json());
}
